import { hlp, escapeAttrValue } from './helpers';
import productImageZoom from './modules/zoom';
import magnificPopup from './modules/magnificpopup';

window.addEventListener('DOMContentLoaded', () => {    

  // Product page description and specs
    $('[data-expand-parent]').click( function() {
        const elExpandable = $(this).parent();
        if( elExpandable.hasClass('expanded') ) {
            const headerOffset = $('.header')[0].offsetHeight;
            const elementPosition = elExpandable[0].getBoundingClientRect().top;

            window.scrollTo({ 
                top: elementPosition + window.scrollY - headerOffset - 50, behavior: 'smooth'
            });            
        }

        elExpandable.toggleClass('expanded');
    });

    $('.product-option-value').click( function() {

        let optionValue = $(this).attr('data-option-value');
        if( optionValue != '' ) {
            $(this).closest('.product-option-item').find( '[data-option-title]' ).text( optionValue );
        }

        let siblingButtons = $(this).find('img').length > 0 ? 
            $(this).siblings('.btn') : $(this).parent().siblings().find('.btn');

        $(this).addClass('active');
        siblingButtons.removeClass('active');
    });
 
    productImageZoom( hlp.isCursor() );
    magnificPopup();
});

window.addEventListener('initialProductZoomResized', (e) => {
    $(`[href="${escapeAttrValue(e.detail)}"]`).addClass( 'product-zoom' );
    productImageZoom( hlp.isCursor() );        
} );